import { statusMeta, TONE_CLASSES, fmtDateTime } from "@/lib/statuses";
import { ShieldAlert, ArrowRight } from "lucide-react";

export const Timeline = ({ events }) => {
  if (!events?.length) {
    return <p className="text-sm text-slate-500">No tracking events recorded yet.</p>;
  }
  return (
    <ol className="relative" data-testid="tracking-timeline">
      {events.map((e, i) => {
        const meta = statusMeta(e.status);
        const Icon = meta.icon;
        const isFirst = i === 0;
        const isCustomsHold = e.status === "held_by_customs";
        return (
          <li key={e.id} className="relative flex gap-4 pb-6 last:pb-0" data-testid={`timeline-event-${i}`}>
            {i < events.length - 1 && (
              <span className="absolute left-[15px] top-8 h-full w-px bg-slate-200" aria-hidden />
            )}
            <span
              className={`relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${TONE_CLASSES[meta.tone]} ${
                isFirst ? "ring-4 ring-orange-100" : ""
              }`}
            >
              <Icon className="h-4 w-4" strokeWidth={2} />
            </span>
            <div className="flex-1 pt-0.5">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <p className={`font-semibold ${isFirst ? "text-slate-900" : "text-slate-700"}`}>{meta.label}</p>
                <span className="font-mono text-xs text-slate-400">{fmtDateTime(e.occurred_at)}</span>
              </div>
              {(e.location_city || e.facility) && (
                <p className="mt-0.5 text-sm text-slate-500">
                  {[e.facility, e.location_city, e.location_country].filter(Boolean).join(" · ")}
                </p>
              )}
              {e.note && <p className="mt-1 text-sm text-slate-600">{e.note}</p>}
              {(e.customs_reason || e.customs_required_action) && (
                <div className="mt-2 rounded-lg border border-amber-300 bg-amber-50 p-3">
                  <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-amber-800">
                    <ShieldAlert className="h-3.5 w-3.5" /> Customs Information
                  </p>
                  {e.customs_reason && (
                    <p className="mt-1 text-sm text-amber-900">
                      <span className="font-medium">Reason:</span> {e.customs_reason}
                    </p>
                  )}
                  {e.customs_required_action && (
                    <p className="mt-1 flex items-start gap-1 text-sm text-amber-900">
                      <ArrowRight className="mt-0.5 h-3.5 w-3.5 shrink-0" />
                      <span><span className="font-medium">Next step:</span> {e.customs_required_action}</span>
                    </p>
                  )}
                </div>
              )}
              {isCustomsHold && !e.customs_reason && (
                <p className="mt-1 text-xs italic text-slate-400">
                  Customs details will appear here once confirmed by our operations team.
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};
